<template>
  <div class="bsList">
    <div class="select">
      <el-form ref="form" :model="request" label-position="right">
          <el-form-item><el-input v-model="request.bsSubjectName" placeholder="商户名称" style="width:150px" clearable></el-input></el-form-item>
          <el-form-item><el-input v-model="request.bsPhone" placeholder="商户电话" style="width:150px" clearable></el-input></el-form-item>
          <el-form-item><el-input v-model="request.csName" placeholder="代理名称" style="width:150px" clearable></el-input></el-form-item>
          <el-form-item><el-input v-model="request.csPhone" placeholder="代理电话" style="width:150px" clearable></el-input></el-form-item>
           <el-form-item>
          <el-select v-model="request.province" clearable placeholder="省" @change="provinceChoose" style="width:150px">
            <el-option v-for="item in this.province" :key="item.code" :label="item.value" :value="item.code" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="request.city" clearable placeholder="市" @change="cityChoose" style="width:150px">
            <el-option v-for="item in this.city" :key="item.code" :label="item.value" :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="request.area" clearable placeholder="区" style="width:150px">
            <el-option v-for="item in this.area" :key="item.code" :label="item.value" :value="item.code"></el-option>
          </el-select>
        </el-form-item>
          <el-form-item>
            <el-button style="background-color:#A9F5F2;margin: 0" icon="el-icon-search" @click="getAllBs">搜索</el-button>
            <el-button style="background-color:#A9F5A9" icon="el-icon-refresh" @click="reset">重置</el-button>
            <el-button style="background-color:#FF4000" icon="el-icon-bottom" @click="exportBsList">导出</el-button>
            <el-button style="background-color:#FFFF00" icon="el-icon-plus" @click="addBs">添加商户</el-button>
            <el-button style="background-color:#0040FF;color: #fff" icon="el-icon-tickets" @click="vipApply">VIP申请</el-button>
        </el-form-item>
       </el-form>
    </div>
    <div class="tableData">
      <el-table :data="response.data"  v-loading="loading" element-loading-text="数据加载中" element-loading-spinner="el-icon-loading" 
                style="margin:auto;width:calc(100% - 30px)" height="715" border :row-style="{ height: '0.3%' }" :cell-style="{ padding: '0.25%' }"
                :header-cell-style="{background:'#01DFD7',color:'#fff'}" element-loading-background="rgba(0.8, 0, 0, 0.3)">
        <el-table-column label="商户编号" width="150" align="center" prop="bsCode"></el-table-column>
        <el-table-column label="商户类型" width="100" align="center" prop="bsType"></el-table-column>
        <el-table-column label="商户名称" width="150" align="center" prop="bsName"></el-table-column>
        <el-table-column label="联系方式" width="130" align="center" prop="bsPhone"></el-table-column>
        <el-table-column label="所属代理" width="300" align="center" prop="csName"></el-table-column>
        <el-table-column label="代理电话" width="130" align="center" prop="csPhone"></el-table-column>
        <el-table-column label="所在地区" width="160" align="center" prop="area"></el-table-column>
        <el-table-column label="详细地址" width="300" align="center" prop="address"></el-table-column>
        <el-table-column label="可见账单" width="100" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.billFlag === '1'">可见</el-tag>
            <el-tag v-if="scope.row.billFlag === '0'">不可见</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="是否分润" width="100" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.rewardFlag === '1'">开通</el-tag>
            <el-tag v-if="scope.row.rewardFlag === '0'">未开通</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="账号状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.delFlag === '1'">冻结</el-tag>
            <el-tag v-if="scope.row.delFlag === '0'">正常</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="warning" plain size="small" @click="modifyBs(scope.row.id)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :current-page="query.current" :total="response.total" @current-change="currenChangeHandle" layout="total, prev, pager, next, jumper" :page-size="query.size"/>
      <add-bs v-if="addBsDialog" ref="addBs" @add-succeed="addSucceed"></add-bs>
      <modify-bs v-if="modifyBsDialog" ref="modifyBs" @modify-succeed="modifySucceed"></modify-bs>
      <vip-apply v-if="vipApplyDialog" ref="vipApply"></vip-apply>
    </div>
  </div>
</template>

<script>
import { exportData, getBsList} from "../../api/usermanagement/bsList.js";
import AddBs from '../relation/addBs.vue';
import ModifyBs from './modifyBs.vue';
import VipApply from './vipApply.vue';
import {GLOBAL_URL} from '../../config/config.js';
import { formatDate } from "../../utils/date";
export default {
  name: "BsManagement",
  components: {AddBs, ModifyBs, VipApply},
  data() {
    return {
      request: {
        bsSubjectName: '',
        bsPhone: '',
        csName: '',
        csPhone: '',
        province: '',
        city: '',
        area: '',
        current: '',
        size: ''
      },
      global: '',
      province: '',
      city: '',
      area: '',
      loading: false,
      query: {current: 1,size: 15},
      response: {data: [],total: 0},
      addBsDialog: false,
      modifyBsDialog: false,
      vipApplyDialog: false
    }
  },
  methods: {

    /**
     * 查询商户列表
     */
    getAllBs() {
      this.request.current = this.query.current;
      this.request.size = this.query.size;
      getBsList(this.request).then((result) => {
        this.response.data = result.data.records;
        this.response.total = result.data.total;
      });
    },

    /**
    * 省下拉框选择触发事件
    */
   provinceChoose(value){
     this.request.city = '';
     this.request.area = '';
     for (let item of this.province) {
      if (value == item.code) {
        this.city = item.childrenDictList
      }
    }
   },

   /**
    * 市下拉框选择触发事件
    */
   cityChoose(value){
     this.request.area = '';
     this.request.area = '';
     for (let item of this.city) {
        if (value == item.code) {
            this.area = item.childrenDictList;
        }
      }
    },

    /**
     * 重置
     */
    reset(){
      this.request.bsSubjectName = "";
      this.request.bsPhone = "";
      this.request.csName = "";
      this.request.csPhone = "";
      this.request.province = "";
      this.request.city = "";
      this.request.area = "";
      this.request.current = "";
      this.request.size = "";
      this.query.current = 1;
      this.getAllBs();
    },

    /**
     * 添加商户
     */
    addBs(){
      this.addBsDialog = true;
      this.$nextTick(() =>{
        this.$refs.addBs.init();
      })
    },

    /**
     * 监听子组件
     */
    addSucceed(value){
      this.getAllBs();
    },

    /**
     * 页码改变触发事件
     */
    currenChangeHandle(value) {
      this.query.current = value;
      this.getAllBs()
    },

    /**
     * 编辑商户
     */
    modifyBs(id){
      this.modifyBsDialog = true;
      this.$nextTick(()=>{
        this.$refs.modifyBs.init(id)
      })
    },

    /**
     * 修改成功重新请求
     */
    modifySucceed(){
      this.getAllBs();
    },

    /**
     * 导出
     */
    exportBsList(){
      this.$notify({
      title: '提示',
      message: '正在准备Excel文件，准备完成之后自动下载，请稍后',
      type: 'success',
      duration: 5000,
      showClose: false,
      position: 'bottom-right'
      });
      exportData(this.request).then(result=>{
        this.$notify.closeAll();
        window.open(GLOBAL_URL.excelUpload+result.data);
      })
    },

    /**
     * vip申请
     */
    vipApply(){
      this.vipApplyDialog = true;
      this.$nextTick(()=>{
        this.$refs.vipApply.init();
      })
    }
  },
  mounted() {
    this.global = JSON.parse(sessionStorage.getItem("dict"));
    this.province = this.global.area;
    this.getAllBs();
  },
  filters: {
    formatDate(time) {
      var date = new Date(time);
      return formatDate(date, "yyyy-MM-dd hh:mm:ss");
    },
  },
};
</script>
<style scoped>
.bsList {
  width: 100%;
  height: 97%;
}
.csList {
  width: 100%;
  height: 100%;
}
.el-form {
  float: left;
}

.el-form-item {
    display: inline-block !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/usermanagement/bslist.vue